<!--首次协议确认-->
<template lang="pug">
  .box(v-if="!isShow")
    .content
      .title 壳保养智慧门店管理协议
      .text
        p(class="red") 请注意：鉴于您是新加入“智慧门店”的用户，请先阅读并确认以下服务协议和隐私条款。
        p(class="m-t-10") 智慧门店服务协议和使用条款和条件
        p(class="m-t-10 t-h") 感谢您选择智慧门店服务。智慧门店服务协议和使用条款和条件（“本协议”）由畅移（上海）信息科技有限公司和您签订。请您在使用智慧门店服务（“服务”或“智慧门店”）之前仔细阅读本协议。
        p(class="m-t-10 font-w") - 重要提示 -
        p(class="m-t-10 t-h") 1)本协议规定了您使用服务的权利和义务，请您仔细阅读（特别是限制或免除智慧门店责任的条款、限制您权利的条款、保密条款、数据保护和隐私政策和法律适用及管辖条款）。
        p(class="m-t-10 t-h") 2) 在您通过移动设备或其他任何设备（“设备”）关注智慧门店或使用服务任何功能时，即表示您确认已阅读、理解本协议并同意受本协议及其他适用法律法规的约束。
        p(class="m-t-10 t-h") 3) 智慧门店可随时变更本协议，并在智慧门店上进行发布。如协议发生变更，您在下次使用本服务时将被要求接受变更后的协议。变更后的协议自发布之日起生效。如您在协议生效后继续使用本服务的，表示您接受变更后的协议，也将遵守变更后的协议使用智慧门店。
        p(class="m-t-10 t-h") 4) 如您不同意本协议，请不要进入智慧门店或使用智慧门店的任何功能。
        p(class="m-t-10") 1.所有权人和运营者信息
        p(class="t-h") 1.1 本服务由畅移（上海）信息科技有限公司拥有和运营。
        p(class="t-h") 1.2 本协议中，如未因任何目的具体指明公司名称，“智慧门店”或“我们”可统指畅移（上海）信息科技有限公司及其关联公司。
        p(class="m-t-10") 2.用户限制和进入
        p(class="t-h") 2.1 本服务仅供有访问权限的智慧门店员工、经销商员工及其他业务合作人员(“授权用户”)使用，不支持公开渠道注册。
        p(class="t-h") 2.2 为使本服务功能正常运作，<span class="red">设备必须正确安装微信或企业微信</span>。您的智慧门店登录名即您注册微信账户时提供或之后绑定的手机号。
        p(class="t-h") 2.3 您离开智慧门店或智慧门店合作商后，您的智慧门店账号将被注销，并不予告知。
        p(class="t-h") 2.4 请注意，使用本服务的部分功能须使用因特网。

        p(class="m-t-10") 3.允许范围内使用
        p(class="t-h") 3.1 您可访问本服务内可见的所有应用；且访问应用权限由本平台服务自动设定，根据智慧门店业务的需求和批准自动设定。
        p(class="t-h") 3.2 在使用智慧门店时，您应遵守中国相关法律法规， 不得利用本服务从事侵害他人合法权益之行为或违反国家法律法规，也不得将本服务用于任何非法目的或以任何非法方式使用本服务，否则智慧门店有权在任何时候不经任何事先通知而单方停止提供服务，且您应独立承担所有相关法律责任；因此导致智慧门店或智慧门店员工或其他方遭受任何损失的，您应承担赔偿责任。具体而言，您在本条项下承诺不予从事的行为包括但不限于：
        p(class="t-h") (a).拷贝（通过截屏、转录或其他方式）、发送、宣传、更改、干涉或以其它方式，使用本服务所含任何内容（如业务数据、品牌营销方案、品牌产品信息、培训内容等），该等限制规定适用于内容的全部及任何部分；
        p(class="t-h") (b).建立本服务链接；
        p(class="t-h") (c).为非法目的或以违反协议的方式非法使用本服务（或其任何部分），采取恶意或欺诈行为，例如，攻击或将病毒、有害数据等恶意代码植入本服务或运行系统；
        p(class="t-h") (d).使用本服务时破坏、禁止、影响、干扰智慧门店系统或安全、使智慧门店系统超负荷运转或干扰其他用户；
        p(class="t-h") (e).通过本服务或我们的系统收集或采集信息或数据，或试图破译运营本服务的服务器接收或传输的任何内容；或；
        p(class="t-h") (f). 对本服务进行复制、编制衍生作品、授予使用许可、出售、转售、反编译、反向工程或反汇编；
        p(class="t-h") (g). 为对本服务服务和/或特点或智慧门店服务器的任何部分进行分解、编入索引、调查或以其它方式进行数据采集之目的责成或发起任何项目或脚本；
        p(class="t-h") (h). 规避或更改本服务的安全技术；
        p(class="t-h") (i). 发表、传送、传播、储存反对宪法所确定的基本原则的、危害国家安全、国家统一或社会稳定的、煽动民族仇恨、民族歧视、破坏民族团结的内容，或侮辱诽谤、色情、暴力、容易引起他人不安或任何违反国家法律法规政策的内容或设置含有上述内容的账户名称或网名；
        p(class="t-h") (j). 侵犯他人名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益。
        p(class="m-t-10") 4. 移动服务
        p(class="t-h") 4.1 您付费后可使用本服务，但须了解，使用本服务仍可能会基于您的电信/运营商的费率收费。本服务包含移动设备可获得的服务和功能。您使用本服务即示您同意我们通过电子方式与您沟通，且我们可获得关于您使用该等服务的情况的信息。如您变更或注销您的移动电话号码，您必须立即更新帐户信息，以确保我们不将向您发送的信息发送至使用您原移动电话号码的人。
        p(class="m-t-10") 5. 赔偿
        p(class="t-h") 5.1 如因您使用内容、您使用本服务、您依赖本服务中包含的任何信息或建议、或违反本协议、任何法律法规或第三方权利导致智慧门店、其关联方、管理人员、董事、员工、代理、许可人和供应商发生任何索赔、损失、责任、支出、损害赔偿和费用（包括但不限于法律费用 ），您同意做出赔偿，为其提供抗辩，使其免于承担责任。
        p(class="m-t-10") 6. 安全
        p(class="t-h") 6.1 您必须将关联本服务的账户信息视为保密，且您不得向第三方进行披露或允许任何未授权人使用您的用户名和/或密码进入本服务。您应对使用您的本服务账户发生的行为或通过您的设备使用本服务承担责任。智慧门店不对因未经授权使用您的用户名和/或密码（不论您是否知悉该情况）导致的损失承担任何责任。
        p(class="m-t-10") 7. 知识产权和保密
        p(class="t-h") 7.1 本服务包含或体现的所有知识产权由智慧门店或其许可人所有。本服务中的任何内容（包括但不限于文本、软件、脚本、代码、设计、图表、照片、声音、音乐、视频、互动应用及其他内容，统称“内容”）为适用著作权法律项下的集体作品，属于智慧门店的专有财产。智慧门店保留针对本服务和内容的相关知识产权的所有权利。
        p(class="t-h") 7.2 本协议的任何规定均不得被理解为许可您使用智慧门店或其许可人的任何知识产权。
        p(class="t-h") 7.3 您承认智慧门店中包含的与智慧门店公司或智慧门店产品有关的任何经营信息、技术信息及其他与实际发生的或拟发生的智慧门店业务活动有关的任何形式或种类的信息均属智慧门店的商业秘密(“保密信息”)，并承诺如下：
        p(class="t-h") (a). 仅为[*]使用保密信息；
        p(class="t-h") (b). 未经智慧门店事先书面同意，不向因职责而合法需要知悉保密信息以外的任何人披露保密信息；
        p(class="t-h") (c). 不向授权用户之外的第三方披露或提供全部或部分保密信息；
        p(class="t-h") (d). 且一旦知悉或怀疑授权用户以外的人员获悉保密信息，在法律允许的范围内应尽快通知智慧门店。
        p(class="m-t-10") 8. 数据保护和隐私政策
        p(class="t-h") 8.1 智慧门店重视对您隐私权的保护。关于您的个人信息将按照《智慧门店隐私政策》受到保护与规范。
        p(class="t-h") 8.2 您在使用本服务时，不应将自认为隐私的信息发表至公开留言和互动栏目，也不应将该等信息通过本服务的服务传播给其他人，由于您自身行为引起的隐私泄漏将由您自行承担责任。
        p(class="m-t-10") 9. 免责声明和责任
        p(class="t-h") 9.1 您将负责您输入或提交给本服务的信息的准确性。智慧门店将尽其最大努力确保作为本服务的一部分提供的信息在输入本服务时准确，但智慧门店不对该信息的准确度或完整性做出保证。
        p(class="t-h") 9.2 您理解并同意，您自行承担风险使用本服务或本服务包含的任何信息或建议。

        p(class="m-t-10") 10. 外部网站和应用
        p(class="t-h") 10.1 本服务可包含外部网站或本服务链接。提供该等链接旨在帮助您迅速快捷地获得您可能需要的相关网站、本服务、服务和/或产品。您应负责确定通过该等网站或本服务提供的产品和/或服务是否满足您的用途。智慧门店不对该等本服务或网站的所有人或运营商、其提供的任何产品或服务或其网站或本服务内容承


        p(class="m-t-10") 隐私政策
        p(class="t-h") 这是针对智慧门店服务（“服务”或“智慧门店”）的隐私政策。
        p(class="t-h") 本隐私政策阐述处理通过以下方式获得的个人资料的信息：
        p(class="t-h") (i) 成为智慧门店或智慧门店经销商的业务人员。
        p(class="t-h") (ii) 访问智慧门店服务。
        p(class="t-h m-t-10") 本隐私政策可能会随着时间的推移而变更，建议您定期查看本隐私政策，随时了解变更。 该隐私政策最后修订于[09/28/2018]。

        p(class="m-t-10") 1. 该隐私政策何时适用?
        p(class="t-h") 如果本应用程序或网站提供链向其他网站或应用程序的链接，请注意这些网站或应用程序已经过公司仔细挑选，但公司不对这些网站或应用程序对您的个人资料的处理方式和结果承担任何责任。 因此，本隐私政策并不适用于对这类网站或应用程序的使用。
        p(class="m-t-10") 2. 谁来掌控您的资料？
        p(class="t-h") 畅移（上海）信息科技有限公司
        p(class="m-t-10") 3. 谁会使用您的资料？
        p(class="t-h") 以下将阐述我们处理哪些类别的个人资料及处理的目的。
        p(class="t-h") 3.1 账户管理和改进服务质量
        p(class="t-h") (a). 此目的意味着什么？
        p(class="t-h") 公司会收集您的账户信息，以设定使用服务的权限。此外，为提升您的服务体验及改进服务质量，我们会定期以调研的形式寻求用户的服务反馈。我们将收集并使用您参与调研时向我们发送的答复信息以获得高质量的评估并改善您的客户体验。
        p(class="t-h") (b). 为实现此目的，我们会处理哪些个人资料？
        p(class="t-h") 我们需要收集并存储您的您姓名和手机号码。
        p(class="t-h") 3.2 个性化资讯
        p(class="t-h") (a). 作为本服务的使用者，您可能收到公司基于分析您使用本服务时行为 信息的提醒/报告（统称“个性化资讯”）。
        p(class="t-h") 通过这些个性化资讯，我们可能使用到您的浏览和互动信息。 公司会收集您的账户信息，以设定使用服务的权限。此外，为提升您的服务体验及改进服务质量，我们会定期以调研的形式寻求用户的服务反馈。我们将收集并使用您参与调研时向我们发送的答复信息以获得高质量的评估并改善您的客户体验。
        p(class="t-h") (b). 为实现此目的，我们会处理哪些个人资料？
        p(class="t-h") 为了给您发送个性化资讯，公司需要理解您的偏好，为此公司会分析：
        p(class="t-h") 您的浏览历史：
        p(class="t-h-4") 这包括以下数据：
        p(class="t-h-4") 您登陆服务/应用的历史记录。
        p(class="t-h") 您的积分兑换/采购信息:
        p(class="t-h-4") 这包括以下数据：
        p(class="t-h-4") 您在兑换积分/购买产品的行为。
        p(class="t-h-4") 您对我们的调查的回应。
        p(class="t-h") (c). 选择拒收个性化资讯
        p(class="t-h") 您可以在任何时候通过取消关注来停止接收个性化资讯。 之后我们将会停止分析您的个人数据和购买偏好，并删除或者匿名处理为了给您提供个性化资讯所储存的任何不再需要的个人资料。
        p(class="t-h") 3.1 反馈和设施
        p(class="t-h") (a). 如果本服务在任何时候提供任何反馈及/或设施（或类似物），公司可能会收集您在使用这类设施的过程中所披露的信息。 这类信息的使用将遵照本隐私政策的有关规定。 请注意，如果您通过本服务中的任何反馈或功能使其它第三方可以获得您的个人资料，那么对于这类第三方对您个人资料的使用，公司无须承担责任。 请谨慎注意您以这种方式披露了哪些个人资料。
        p(class="m-t-10") 4. 谁有权访问您的资料？
        p(class="t-h") 公司可以把您的个人资料披露给任何以下人士：
        p(class="t-h") 畅移（上海）信息科技有限公司及其关联公司；
        p(class="t-h") 公司通过第三方进行某些处理，例如：网站托管。 作为提供给您的服务的一部分，收集的个人资料可能会转让给位于欧洲经济区（EEA）以外且得到授权的第三方。 举例来说，如果我们的任何服务器有时会位于 EEA 以外的国家，或我们的某个服务供应商可能位于 EEA 以外的国家，则就会出现上述情形。 对于有权访问您的个人资料以便执行这些处理事宜的这些第三方，公司已采用必须的组织及/或合约措施来确保您的个人资料仅出于上述目的被处理和使用，而且已实施充分的保护以便保障您个人资料的安全。
        p(class="t-h") 除了本隐私政策中阐述的以外，未经您的许可，我们不会披露您的任何个人资料，除非法律规定或者赋予我们这样做的权利，或者我们认为为了保护及/或捍卫我们以及我们的用户/客户或其他个体的权利、财产或个人安全必须采取这类行为。 只有在法律规定公司必须这样做时，才会将您的个人资料提供给监管机构、财政当局以及调查机关。
        p(class="m-t-10") 5. 我们对您的个人资料保留多长时间？
        p(class="t-h") 根据您停止使用“智慧门店服务”的要求或者通过取消关注之行为，我们会尽合理可能地关闭相应的账户。 此外，我们还会关闭或停用那些不活跃客户的账户，以及关闭使用时违反本隐私政策或者适用条款和条件的账户。 对于被关闭或被停用账户中的个人资料，我们会尽可能合理地尽快删除或者匿名呈现。 在某些情况下，我们还会对关闭或停用账户中的个人资料再保留一段时间，这样做是为了防止欺诈或者采取法律允许或规定的行动。
        p(class="m-t-10") 6. 通过社交媒体分享我们的网站或内容
        p(class="t-h") 如您选择通过社交媒体（例如微信）来分享我们的服务或内容，您的个人数据（例如您的名字和您对公司感兴趣这一事实）将同样对所有可进入您在微信个人页面的访客可见。对该等社交媒体网站的使用将适用该等社交媒体网站自身的条款和条件（包括隐私政策）。公司不负责该等社交媒体网站上的个人数据处理和隐私政策，因此公司隐私政策不适用。
        p(class="m-t-10") 7. 我们的WeChat页面
        p(class="t-h") 我们有一个WeChat页面。当您通过WeChat页面和我们交流的时候（例如当您发表评论、上传媒体文件、发送个人信息，我们可能会收到关于您的个人信息（例如您作为使用者的名字、资料照片）。WeChat隐私政策已描述我们使用您的个人数据的方式，但除此之外，以下条款亦适用：
        p(class="t-h") （i）本隐私政策
        p(class="t-h") （ii）WeChat的使用条件和其他陈述。
        p(class="t-h")  公司鼓励您仔细阅读WeChat的使用条件和其他陈述，其可能会和本隐私政策有所区别。
        p(class="m-t-10") 8. 我们如何确保您的个人资料的安全？
        p(class="t-h") 我们采用了相关的技术和政策，目的是要保护您的隐私免遭未经授权的访问及不当使用。
        p(class="m-t-10") 9. 我们如何确保您的个人资料的安全？
        p(class="t-h") 我们力争确保与您有关的数据尽可能准确。 如果您希望查看、变更或删除提供给我们的详细信息，请将您的要求通过电子邮件(aisupport@vchangyi.com)发送给公司的工作人员，或拨打我们的联系电话400-860-6961。
        p(class="t-h-4") 我已逐条检查并确认以上内容
      .submit-box
        .button(@click="agreeOp") 同意条款

</template>

<script>
  import store from '../../vuex/store'
  import { mapGetters } from 'vuex'
  import userMixin from '@/mixins/modules/user'
  export default {
    name: 'agreementModel',
    mixins: [userMixin],
    data () {
      return {
        isShow: false,
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'currentUser',
      }),
    },
    methods: {
      async agreeOp () {
        try {
          const {response, result} = await this.updataUserInfo()
          if (response.status === 200) {
            this.isShow = true
            this.currentUser.agree = 1
            store.dispatch('updateUser', this.currentUser)
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '网络异常',
              content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
            })
          }
        } catch ({err}) {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '网络异常',
            content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
          })
        }
      },
    },
    mounted () {
      this.isShow = this.currentUser.agree
    },
  }
</script>

<style scoped lang="stylus">
@import '~@/stylus/mixins'
.m-t-10
  margin-top 10px
.font-w
  font-weight bold
p
  line-height 1.2
.red
  color red
.t-h
  text-indent 2em
.t-h-4
  text-indent 4em
.box
  width 100%
  height 100%
  position fixed
  top 0
  left 0
  background-color rgba(0,0,0,.5)
  z-index 999
  display: flex;
  align-items: center;
  .content
    width 600px
    height 90%
    background-color #ffffff
    margin auto
    padding 0 30px
    .title
      line-height 30px
      text-align center
      font-size 24px
      padding-top 20px
      padding-bottom 20px
    .text{
      width 100%
      height 80%
      border 1px solid #72767a
      overflow-y auto
      padding 10px 20px
    }
    .submit-box
      width 100%
      height 40px
      .button
        width 120px
        height 40px
        text-align center
        color #fff
        font-size 18px
        line-height 40px
        background-color #FFBB29
        border-radius borderRadius
        box-shadow 0 1px 3px 0 rgba(0, 0, 0, .05)
        cursor pointer
        display block
        margin 0 auto
        margin-top 10px
        &:hover
          background-color #FFC723
          box-shadow 0 4px 6px 0 rgba(255, 199, 35, .3), 0 4px 24px 0 rgba(0, 0, 0, .05)


</style>



// WEBPACK FOOTER //
// src/components/generics/agreementModel.vue